import React, {SyntheticEvent} from "react";
import {observer} from "mobx-react";
import {
    FlightsDatesSelector
} from "../../../../services/flight-search/dates-selection/flights-dates-selector";
import styled from "styled-components";
import {
    DepartureDateSelectionStrategyIndicatorComponent, ReturnDateSelectionStrategyIndicatorComponent
} from "./date-selection-strategy-indicator.component";


const HeaderContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    cursor: default;
`

interface FlightDatesDropdownHeaderInOpenStateComponentProps {
    datesSelector: FlightsDatesSelector;
}

export const FlightDatesDropdownHeaderInOpenStateComponent: React.FC<FlightDatesDropdownHeaderInOpenStateComponentProps> = observer((props) => {
    const onClickHandler = (event: SyntheticEvent) => {
        event.stopPropagation();
    }
    return (
        <HeaderContainerBox onClick={onClickHandler}>
            <DepartureDateSelectionStrategyIndicatorComponent datesSelector={props.datesSelector}/>
            <ReturnDateSelectionStrategyIndicatorComponent datesSelector={props.datesSelector}/>
        </HeaderContainerBox>
    )
});
